import InterviewContextProvider from "../InterviewContext";

import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import InterviewDetailsContent from "./InterviewContent";

const NewInterview = ({ match }) => {
  const { t } = useTranslation();

  return (
    <InterviewContextProvider>
      <InterviewDetailsContent interviewId={match.params.id} />
    </InterviewContextProvider>
  );
};

export default NewInterview;

NewInterview.propTypes = {
  match: PropTypes.object.isRequired
};
